import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import { FC } from "react";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import type { CondCategory } from "../../../../http/envelopeDesigner/types/condCategory";
import { useMaterialClassificationApi } from "../../../../http/envelopeDesigner/useAdminEnvelopeDesigner";
import CondCategoryFormDialog from "./CondCategoryFormDialog";

// The admissible-condensate categories (UNI EN ISO 13788): edit only, their codes are the calculation's.
const CondCategoriesTab: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.envelopeDesignerModule.admin;
  const { condCategories } = useMaterialClassificationApi();

  return (
    <AdminCrudTable<CondCategory>
      filterPrefix="cond_categories"
      useList={condCategories.useSearch}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.code}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>
          <TableHeadCell align="left">{t.rule}</TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.code}</TableCell>
          <TableCell>{item.name}</TableCell>
          <TableCell>{item.rule}</TableCell>
        </>
      )}
      renderForm={(item, onClose) => <CondCategoryFormDialog condCategory={item} onClose={onClose} />}
    />
  );
};

export default CondCategoriesTab;
